/**
 * actions/index.js
 *
 * All actions are listed here.  Whenever a new action is added. Add it here and import it from here.
 *
 * Example import usage:
 * import { UserActions } from 'actions';
 */

import NavActions from './NavActions';

export default NavActions;



// WEBPACK FOOTER //
// ./app/scripts/actions/index.js